import React from 'react'

import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'

import { useTranslation } from 'react-i18next'
import PageHeroTitle from '../components/PageHeroTitle'
import BottomImage from '../components/BottomImage'

const FAQ = () => {
  const { t } = useTranslation()
  const pageName = 'FAQ'

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle
        title={t(`${pageName}`)}
        description={t(`${pageName}_DESCRIPTION`)}
      />

      <BottomImage name={pageName} />

      <Footer />
    </div>
  )
}

export default FAQ
